import _ from 'lodash'

export default function chunkRootCauses(rootCauses, chunkSize = 1) {
  return _.chunk(_.sortBy(rootCauses, 'position') || [], chunkSize)
}
